import startOfMinute from '@teetsh/app/src/utils/time/startOfMinute';
import setHours from '@teetsh/app/src/utils/time/setHours';
import setMinutes from '@teetsh/app/src/utils/time/setMinutes';
import setDay from '@teetsh/app/src/utils/time/setDay';

export function getDayOfWeek(
  weekday: number,
  hour: number,
  minutes: number,
): Date {
  const date = startOfMinute(new Date());
  const dateWithHour = setHours(date, hour);
  const dateWithMinutes = setMinutes(dateWithHour, minutes);
  return setDay(dateWithMinutes, weekday, false);
}
